import Button from 'components/Button';
import Error from 'components/form/Error';
import { MenteeStatusValues } from 'enums/MenteeStatus';
import { FC, useContext, useState } from 'react';
import styled from 'styled-components';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';
import { ButtonsContainer } from '.';
import { MenteeEditContext } from '../..';

const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 1rem;
  }
  margin-bottom: 1rem;
`;

const MenteeRefused: FC = () => {
  const { mentee } = useContext(MenteeEditContext);
  const [eligibleLoading, setEligibleLoading] = useState(false);
  const [refuseLoading, setRefuseLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);

  const handleSetElligible = () => {
    setEligibleLoading(true);
    setError(false);
    privateAPI
      .patch(`/user/status/${mentee?.id}`, {
        menteeStatus: 'ELIGIBLE' as MenteeStatusValues,
      })
      .then(() => {
        mutate(`/user/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}/ongoing`);
      })
      .catch(() => {
        setError(true);
        setEligibleLoading(false);
      });
  };

  const handleRefuse = () => {
    setRefuseLoading(true);
    setError(false);
    privateAPI
      .patch(`/user/status/${mentee?.id}`, {
        menteeStatus: 'REFUSED' as MenteeStatusValues,
      })
      .then(() => {
        mutate(`/user/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}/ongoing`);
      })
      .catch(() => {
        setError(true);
        setRefuseLoading(false);
      });
  };

  return (
    <div>
      <ActionContainer>
        <p>
          Le mentorat a été refusé par le mentoré. Quelle action souhaitez-vous
          effectuer ?
        </p>
        <ButtonsContainer>
          <Button
            color="primary"
            onClick={handleSetElligible}
            loading={eligibleLoading}
          >
            Créer un nouveau mentorat
          </Button>
          <Button
            color="primary"
            onClick={handleRefuse}
            loading={refuseLoading}
          >
            Refuser le mentorat
          </Button>
        </ButtonsContainer>
      </ActionContainer>
      {error && <Error>Une erreur est survenue.</Error>}
    </div>
  );
};

export default MenteeRefused;
